<template>
    <div id="ag-grid-demo">
        <vx-card :title="$t('Tasks')">

            <!-- TABLE ACTION ROW -->
            <div class="flex flex-wrap justify-between items-center">

                <!-- ITEMS PER PAGE -->
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">

                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ tasks.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : tasks.length }} of {{ tasks.length }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="gridApi.paginationSetPageSize(50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="gridApi.paginationSetPageSize(150)">
                                <span>150</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>

                    <div style="float: right" v-if="$checkPermission(1102)">
                        <vs-button style="float:left;" class="ml-6 mt-1" type="border" color="success" @click="addInvoicingGroup" >{{$t("CreateInvoicingGroup")}}</vs-button>
                        <vs-button style="float:left;" class="ml-6 mt-1" type="border" color="success" @click="openTaskToInvoiceGroupAdding" >{{$t("AddToInvoicingGroup")}}</vs-button>

                    </div>


                </div>


                <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
                <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
                    <vs-input class="mb-4 md:mb-0 mr-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
                    <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button>
                    <vs-button class="ml-3" type="border" color="success" @click="resizeColumns" icon-pack="feather" icon="icon-maximize-2"></vs-button>
                </div>
            </div>

            <ag-grid-vue
                    ref="agGridTable"
                    :gridOptions="gridOptions"
                    class="ag-theme-material w-100 my-4 ag-grid-table"
                    :columnDefs="columnDefs"
                    :defaultColDef="defaultColDef"
                    :rowData="tasks"
                    :groupSelectsFiltered="true"
                    rowSelection="multiple"
                    colResizeDefault="shift"
                    domLayout="autoHeight"
                    :animateRows="true"
                    :floatingFilter="true"
                    :pagination="true"
                    :paginationPageSize="paginationPageSize"
                    :suppressPaginationPanel="true">
            </ag-grid-vue>
            <vs-pagination
                    :total="totalPages"
                    :max="maxPageNumbers"
                    v-model="currentPage" />

        </vx-card>

        <vs-popup :title="$t('Add')" :active.sync="activeAddToGroupPrompt" style="z-index: 54000">
            <div>
                <vs-select autocomplete class="selectExample" v-model="selectedInvoicingGroup">
                    <vs-select-item :key="index" :value="item.id" :text="item.invoice_id + ' - ' + moment(item.created).format('DD/MM/YYYY HH:mm')" v-for="(item,index) in selectedTasksClientInvoicingGroups" />
                </vs-select>
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="addToInvoicingGroup">{{$t("Add")}}</vs-button>
            </div>
        </vs-popup>

    </div>
</template>

<script>
    import { AgGridVue } from "ag-grid-vue"
    import PriorityRenderer from "../Task/PriorityRenderer";
    import StatusRenderer from "../Task/StatusRenderer";

    import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
    import PriorityEditor from "../Task/PriorityEditor";
    import AssignedUserEditor from "../Task/AssignedUserEditor";
    import TimeRenderer from "../Task/TimeRenderer";
    import TaskNameRenderer from "../Task/TaskNameRenderer";

    export default {
        components: {
            AgGridVue,
            PriorityRenderer,
            StatusRenderer,
            PriorityEditor,
            AssignedUserEditor,
            TimeRenderer,
            TaskNameRenderer
        },
        data() {
            return {

                searchQuery: '',
                gridOptions: {
                    suppressRowClickSelection: true,
                    onCellClicked: (e) => {
                        if (e.column.colId === 'title' || e.column.colId === 'client_company_id') {
                            this.selectedTaskId = e.data.id;
                            this.$router.push({ name: 'task', params: { id: "" + this.selectedTaskId } })
                        }
                    },
                    onRowDataChanged: () => {
                        this.$nextTick(() => {
                            this.gridColumnApi.autoSizeColumns([ 'branch_office', 'contract_hours', 'company_task_id', 'client_company_id', 'title', 'company_user_id', 'status', 'added_time', 'project']);
                            if(this.columnsWidth < this.tableWidth){
                                this.gridApi.sizeColumnsToFit()
                            }
                        });
                    }
                },
                maxPageNumbers: 7,
                gridApi: null,
                gridColumnApi: null,
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true,
                },
                columnDefs: [
                    {
                        headerName: "",
                        headerCheckboxSelection: true,
                        headerCheckboxSelectionFilteredOnly: true,
                        checkboxSelection: true,
                        width: 50
                    },
                    {
                        headerName: "ID",
                        field: 'company_task_id',
                        filter: true,
                        width: 80
                    },
                    {
                        headerName: this.$t("Client"),
                        field: 'client_company_id',
                        filter: true,
                        valueGetter: this.companyValueGetter
                    },
                    {
                        headerName: this.$t("ContractHours"),
                        field: 'contract_hours',
                        filter: true,
                    },
                    {
                        headerName: this.$t("TaskTitle"),
                        field: 'title',
                        filter: true,
                    },
                    {
                        headerName: this.$t("Project"),
                        field: 'project',
                        filter: true,
                        width: 80,
                        valueGetter: this.projectValueGetter,
                    },
                    {
                        headerName: this.$t("BranchOffice"),
                        field: 'branch_office',
                        filter: true,
                    },
                    {
                        headerName: this.$t("Status"),
                        field: 'status',
                        filter: true,
                        valueGetter: this.statusValueGetter,
                    },
                    {
                        headerName: this.$t("AssignedUser"),
                        field: 'company_user_id',
                        filter: true,
                        cellStyle: {'background-color': 'rgb(0,0,0,0)'},
                        valueGetter: this.userValueGetter
                    },
                    {
                        headerName: this.$t("Added"),
                        field: 'added_time',
                        filter: true,
                        width: 150,
                        cellRendererFramework: TimeRenderer,
                    },
                ],
                tasks: [],
                selectedTasks: [],
                selectedInvoicingGroup: '',
                selectedTasksClientInvoicingGroups: [],
                activeAddToGroupPrompt: false,
            }
        },
        created() {
            this.updateTasks()
        },
        watch: {
            '$store.state.windowWidth'(val) {
                if(val <= 576) {
                    this.maxPageNumbers = 4;
                    this.gridOptions.columnApi.setColumnPinned('title', null)
                }
                else this.gridOptions.columnApi.setColumnPinned('title', 'left')
            },
        },
        computed: {
            columnsWidth() {
                let total = 0;
                let state = this.gridColumnApi.getColumnState();
                for(let x = 0; x < state.length; x++){
                    total += state[x].width
                }
                return total;
            },
            tableWidth() {
                return this.gridApi.gridPanel.eBodyViewport.clientWidth;
            },
            paginationPageSize() {
                if(this.gridApi) return this.gridApi.paginationGetPageSize()
                else return 50
            },
            totalPages() {
                if(this.gridApi) return this.gridApi.paginationGetTotalPages()
                else return 0
            },
            currentPage: {
                get() {
                    if(this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
                    else return 1
                },
                set(val) {
                    this.gridApi.paginationGoToPage(val - 1)
                }
            }
        },
        methods: {
            resizeColumns(){
                this.gridColumnApi.autoSizeColumns(['branch_office', 'contract_hours', 'company_task_id', 'client_company_id', 'title', 'company_user_id', 'status', 'added_time', 'project']);
                if(this.columnsWidth < this.tableWidth){
                    this.gridApi.sizeColumnsToFit()
                }
            },
            updateSearchQuery(val) {
                this.gridApi.setQuickFilter(val)
            },
            updateTasks() {
                const thisIns = this;
                this.$http.get('/api/v1/invoicing_group/tasks')
                    .then(function (response) {
                        thisIns.tasks = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            companyValueGetter(param){
                if(this.$store.getters.companyClients[param.data.client_company_id] === undefined) return "";
                return this.$store.getters.companyClients[param.data.client_company_id].name
            },
            userValueGetter(param){
                if(this.$store.getters.companyUsers[param.data.company_user_id] === undefined || param.data.company_user_id === 0) return "";
                return this.$store.getters.companyUsers[param.data.company_user_id].name
            },
            projectValueGetter(param){
                if (param.data.project > 0) return this.$t("Yes");
                return this.$t("No");
            },
            statusValueGetter(param){
                switch (param.data.status) {
                    case 0:
                        return this.$t("Unassigned");
                    case 1:
                        return this.$t("Open");
                    case 2:
                        return this.$t("InProgress");
                    case 3:
                        return this.$t("Waiting");
                    case 4:
                        return this.$t("SentForConfirmation");
                    case 5:
                        return this.$t("Confirmed");
                    case 6:
                        return this.$t("Invoiced");
                    default:
                        return ""

                }
            },
            addInvoicingGroup() {

                let list = [];
                const selectedRows = this.gridApi.getSelectedRows();

                if(selectedRows.length === 0) {
                    this.$vs.notify({
                        title:'Warning',
                        text: "No data selected!",
                        position:'top-right',
                        color:'warning',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'});
                    return
                }

                let clientCompanyId = selectedRows[0].client_company_id;

                for(let x = 0; x < selectedRows.length; x++) {

                    if(selectedRows[x].client_company_id !== clientCompanyId) {
                        this.$vs.notify({
                            title:'Error',
                            text: "More than one client in group!",
                            color:'danger',
                            position:'top-right',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'});
                        return;
                    }

                    list.push(selectedRows[x].id);

                }

                const thisIns = this;
                this.$http.post('/api/v1/invoicing_group/group', JSON.stringify(list)).then(function () {
                    thisIns.$vs.notify({
                        title:'Success',
                        text: "Created",
                        color:'success',
                        position:'top-right',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'});
                    thisIns.updateTasks();
                }).catch(function (error) {
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        position:'top-right',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });

            },
            openTaskToInvoiceGroupAdding(){

                const selectedRows = this.gridApi.getSelectedRows();

                if(selectedRows.length === 0) {
                    this.$vs.notify({
                        title:'Warning',
                        text: "No data selected!",
                        position:'top-right',
                        color:'warning',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'});
                    return
                }

                let clientCompanyId = selectedRows[0].client_company_id;

                for(let x = 0; x < selectedRows.length; x++){
                    if(selectedRows[x].client_company_id !== clientCompanyId) {
                        this.$vs.notify({
                            title:'Error',
                            text: "More than one client in group!",
                            color:'danger',
                            position:'top-right',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'});
                        return;
                    }
                }

                const thisIns = this;
                this.$http.get('/api/v1/invoicing_group/waiting/client/' + clientCompanyId)
                    .then(function (response) {
                        thisIns.selectedTasksClientInvoicingGroups = response.data;
                        thisIns.activeAddToGroupPrompt = true;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });



            },
            addToInvoicingGroup() {

                let list = [];
                const selectedRows = this.gridApi.getSelectedRows();

                if(selectedRows.length === 0) {
                    this.$vs.notify({
                        title:'Warning',
                        text: "No data selected!",
                        position:'top-right',
                        color:'warning',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'});
                    return
                }

                let clientCompanyId = selectedRows[0].client_company_id;

                for(let x = 0; x < selectedRows.length; x++) {

                    if(selectedRows[x].client_company_id !== clientCompanyId) {
                        this.$vs.notify({
                            title:'Error',
                            text: "More than one client in group!",
                            color:'danger',
                            position:'top-right',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'});
                        return;
                    }

                    list.push(selectedRows[x].id);

                }

                const thisIns = this;
                this.$http.post('/api/v1/invoicing_group/group/' + this.selectedInvoicingGroup + "/task", JSON.stringify(list)).then(function () {
                    thisIns.$vs.notify({
                        title:'Success',
                        text: "Added",
                        color:'success',
                        position:'top-right',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'});
                    thisIns.updateTasks();
                    thisIns.activeAddToGroupPrompt = false;
                }).catch(function (error) {
                    thisIns.activeAddToGroupPrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error.response.data,
                        color:'danger',
                        position:'top-right',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });

            }
        },
        mounted() {
            this.gridApi = this.gridOptions.api;
            this.gridColumnApi = this.gridOptions.columnApi;
        },

        beforeRouteLeave (to, from, next) {
            if(this.activeNewTaskPrompt){
                this.activeNewTaskPrompt = false;
                next(false)
            }else{
                next()
            }
        }
    };

    function isFirstColumn(params) {
        let displayedColumns = params.columnApi.getAllDisplayedColumns();
        let thisIsFirstColumn = displayedColumns[0] === params.column;
        return thisIsFirstColumn;
    }

</script>
